
import { defineComponent, ref, watch, onMounted } from 'vue'

export default defineComponent({
    name: 'FormColorPicker',
    props: {
        color: String,
        label: String,
        defaultValue: {
            type: String,
            required: true
        }
    },
    emits: ['updateSlider'],
    setup(props, { emit }) {
        const sliderValue = ref<number>(parseInt(props.color || props.defaultValue));

        const onSliderUpdate = () => {
            emit('updateSlider', sliderValue.value.toString());
        }

        watch(() => props.color, (val) => {
            sliderValue.value = parseInt(val || props.defaultValue)
        });

        return {
            sliderValue,
            onSliderUpdate
        };
    }
})
